import { Controller } from '@hotwired/stimulus'

const RELOAD_DELAY_MS = 200

export default class extends Controller<HTMLElement> {
  static targets = ['spinner', 'text']
  static values = {
    shouldRefresh: Boolean,
    cancelConfirmLeave: Boolean,
    disableOnSubmit: Boolean,
    disableWith: String
  }

  declare readonly spinnerTarget: HTMLDivElement
  declare readonly textTarget: HTMLSpanElement
  declare readonly hasSpinnerTarget: boolean
  declare readonly hasTextTarget: boolean

  declare shouldRefreshValue: boolean
  declare cancelConfirmLeaveValue: boolean
  declare disableOnSubmitValue: boolean
  declare disableWithValue: string

  #disableElement(): void {
    if (this.element instanceof HTMLButtonElement) {
      this.element.disabled = true
      return
    }

    this.element.setAttribute('data-disabled', '')
    this.element.setAttribute('aria-disabled', 'true')
  }

  #replaceText(): void {
    if (!this.hasTextTarget || !this.disableWithValue) return

    this.textTarget.textContent = this.disableWithValue
  }

  #handleDisableOnSubmit = (e: MouseEvent): void => {
    if (!this.disableOnSubmitValue) return

    const isButton = this.element instanceof HTMLButtonElement
    const isDisabled = this.element.dataset.disabled !== undefined

    if (!isButton && isDisabled) {
      e.preventDefault()
    }

    this.#disableElement()
    this.#replaceText()
  }

  connect(): void {
    if (this.element.parentElement?.tagName === 'FORM') {
      if (this.shouldRefreshValue) {
        this.element.parentElement?.addEventListener('submit', () => {
          if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove('hidden')
          this.#disableElement()
          setTimeout(() => {
            window.location.reload()
          }, RELOAD_DELAY_MS)
        })
      }
    }
    if (this.disableOnSubmitValue) {
      this.element.addEventListener('click', this.#handleDisableOnSubmit)
    }
    if (this.cancelConfirmLeaveValue) {
      this.element.addEventListener('click', () => {
        ;(window as any).cancelConfirmLeave()
      })
    }
  }

  disconnect(): void {
    if (this.disableOnSubmitValue) {
      this.element.removeEventListener('click', this.#handleDisableOnSubmit)
    }
  }
}
